<ng-container *ngIf="ablaufmanagementFonds$ | async as fonds">
<form class="lv-artefact-container lv-component "
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-ablaufmanagement-header">
    <div>
      <lv-label-tooltip [label]="'Fonds'"
                        [tooltip]="'TOOLTIPS.ABLAUFMANAGEMENT_FONDS' | translate"></lv-label-tooltip>
      <ng-container *ngIf="!!dataSource && !!dataSource.data.length">
        <lv-anlauf-ablauf-management-table [dataSource]="dataSource"></lv-anlauf-ablauf-management-table>
      </ng-container>
    </div>
  </div>
</form>
